import { fetchLayers } from '@app/domains/layers/services/layers.service'
import type { DialogData } from '@app/types'
import { useQuery } from '@tanstack/react-query'
import { useAtomValue } from 'jotai'
import { clientNameAtom } from '@app/state/clientsAtom'
import { useFeatureFlags } from '@app/hooks/useFeatureFlags'
import { FEATURE_FLAGS } from '@app/app-constants'

/**
 * Fetches map layers and caches them with React Query.
 * Pass a clientName so the query is refetched when the client changes.
 */
export function useFetchLayer() {
  const clientNameFromAtom = useAtomValue(clientNameAtom)
  const { useFeatureFlag } = useFeatureFlags()
  const riskModule = useFeatureFlag(FEATURE_FLAGS.RISK_MODULE)

  return useQuery<DialogData>({
    queryKey: ['layers', clientNameFromAtom],
    queryFn: fetchLayers,
    enabled: Boolean(clientNameFromAtom) && riskModule,
    refetchOnMount: true,
  })
}
